module.exports = __webpack_public_path__ + "img/PGlogo.da51d5cb.png";